import IconComponent from "@mdi/react";
import { createPortal } from "react-dom";

import { mdiContentCopy } from "@mdi/js";
import styled from "styled-components/macro";

import { ContextMenuState } from "./hooks/useChartDataTableContextMenu";
import { ContextMenuAction } from "./hooks/useChartDataTableInteractions";

interface ChartDataTableContextMenuProps {
  contextMenu: ContextMenuState;
  onAction: (action: ContextMenuAction) => void;
}

export function ChartDataTableContextMenu({
  contextMenu,
  onAction
}: ChartDataTableContextMenuProps) {
  const isColumnMenu = contextMenu.columnName && !contextMenu.cellValue;

  return createPortal(
    <ContextMenuWrapper
      style={{
        position: "fixed",
        top: contextMenu.y,
        left: contextMenu.x,
        zIndex: 10000
      }}>
      {isColumnMenu ? (
        <ContextMenuItem onClick={() => onAction(ContextMenuAction.CopyColumn)}>
          <IconComponent path={mdiContentCopy} size={0.8} />
          Copy Column
        </ContextMenuItem>
      ) : (
        <>
          <ContextMenuItem onClick={() => onAction(ContextMenuAction.CopyCell)}>
            <IconComponent path={mdiContentCopy} size={0.8} />
            Copy Cell
          </ContextMenuItem>
          <ContextMenuItem onClick={() => onAction(ContextMenuAction.CopyRow)}>
            <IconComponent path={mdiContentCopy} size={0.8} />
            Copy Row
          </ContextMenuItem>
        </>
      )}
    </ContextMenuWrapper>,
    document.body
  );
}

const ContextMenuWrapper = styled.div`
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 4px 0;
  min-width: 150px;
`;

const ContextMenuItem = styled.div`
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;

  &:hover {
    background-color: #f5f5f5;
  }
`;
